import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions, alertActions } from '_actions';

class DBDecimalField extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
            changingTimeout: 0,
            hasChanges: false
        };
        this.handleValueChange = this.handleValueChange.bind(this);
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.saveValue = this.saveValue.bind(this);
    }

    componentDidMount() {
        this.setState((state) => {
            return { value: this.props.value };
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.noteId !== prevProps.noteId ||
            this.props.entity !== prevProps.entity ||
            this.props.entityKeyValue !== prevProps.entityKeyValue ||
            this.props.value !== prevProps.value ||
            this.props.field !== prevProps.field) {
            this.setState((state) => {
                return { value: this.props.value, hasChanges: false };
            })
        }
    }

    handleValueChange(event) {
        if (this.state.changingTimeout) {
            clearTimeout(this.state.changingTimeout);
        }

        var regexStr = '^(\\d{0,' + (this.props.precision - this.props.scale) + '}(\\.\\d{0,' + this.props.scale + '})?$)';
        var regex = new RegExp(regexStr);
        const validated = event.target.value.match(regex);
        if (validated) {
            this.setState({
                value: event.target.value,
                hasChanges: true,
                changingTimeout: setTimeout(() => this.saveValue(), 2000)
            });
        }
    }

    saveValue() {
        if (this.state.hasChanges === true) {
            if (this.state.value === '') {
                this.props.clearField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field);
            } else if (isNaN(this.state.value)) {
                this.props.alertWarning('Input is invalid');
            } else if (this.props.min && parseFloat(this.state.value) < this.props.min) {
                this.props.alertWarning('The minimum value for this field is: ' + this.props.min);
            } else if (this.props.max && parseFloat(this.state.value) > this.props.max) {
                this.props.alertWarning('The maximum value for this field is: ' + this.props.max);
            } else {
                this.props.updateDecimalField(this.props.noteId, this.props.entity, this.props.entityKeyColumn, this.props.entityKeyValue, this.props.field, parseFloat(this.state.value));
            }
        }
        this.setState({ hasChanges: false });
    }

    handleOnBlur() {
        if (
            this.state.value !== '' &&
            (
                isNaN(this.state.value) ||
                (this.props.min && parseFloat(this.state.value) < this.props.min) ||
                (this.props.max && parseFloat(this.state.value) > this.props.max)
            )
        ) {
            this.setState({ value: this.props.value });
        }
        this.saveValue();
        clearTimeout(this.state.changingTimeout);
    }

    render() {
        return (
            <input
                className={this.props.className ? this.props.className : ''}
                type="text"
                min={this.props.min}
                max={this.props.max}
                onKeyPress={this.handleKeyPress}
                title={this.props.title ? this.props.title : ''}
                onChange={this.handleValueChange}
                onBlur={this.handleOnBlur}
                value={this.state.value} />
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateDecimalField: bindActionCreators(noteActions.updateDecimalField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        alertWarning: bindActionCreators(alertActions.warningMsg, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    return {
        value: state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== undefined
            && state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] !== null ?
            state.entities.notes[ownprops.entity][ownprops.entityKeyValue][ownprops.field] : '',
        scale: state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field].NUMERIC_SCALE,
        precision: state.entities.masterData.PTERONOTESCHEMA[ownprops.entity + '.' + ownprops.field].NUMERIC_PRECISION,
    };
}

const connectedDBDecimalField = connect(mapStateToProps, mapDispatchToProps)(DBDecimalField);
export { connectedDBDecimalField as DBDecimalField };